module.exports = __webpack_public_path__ + "static/media/poste_11.70f9691a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_11.jpg
// module id = 239
// module chunks = 0